import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  ModalFooter,
  Spinner,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import toast from "react-hot-toast";
import CustomerTypeService from "../../../services/OrderingServices/CustomerTypeService";
import Select from "react-select";

// Validation Schema
const validationSchema = Yup.object({
  // username: Yup.string().required("Username is required"),
  firstName: Yup.string().required("First name is required"),
  // lastName: Yup.string().required("Last name is required"),
  // email: Yup.string()
  //   .email("Invalid email address")
  //   .matches(
  //     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  //     "Enter a valid email address"
  //   )
  //   .required("Email is required"),
  // address: Yup.string().required("Address is required"),
  phoneNo: Yup.string()
    .required("Phone number is required")
    .matches(/^[0-9]+$/, "Phone number must be digits only")
    .min(10, "Phone number must be at least 10 digits")
    .max(10, "Phone number must be exactly 10 digits"),
  customerTypeId: Yup.number().nullable().required("Customer type is required"),
});

const MobileCustomerForm = ({
  selectedCustomer,
  modal,
  toggleModal,
  fetchCustomers,
  onCustomerAdded,
}) => {
  const [loading, setLoading] = useState(false);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const fetchCustomerType = async () => {
    try {
      const response = await CustomerTypeService.getList();
      setCustomerTypeData(response.items || []);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCustomerType();
  }, []);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedCustomer?.id || "",

      // username: selectedCustomer?.username || "",
      firstName: selectedCustomer?.firstName || "",
      lastName: selectedCustomer?.lastName || "",
      email: selectedCustomer?.email || "",
      address: selectedCustomer?.address || "Kathmandu",
      phoneNo: selectedCustomer?.phoneNo
        ? String(selectedCustomer.phoneNo)
        : "9800000000",
      customerTypeId: selectedCustomer?.customerTypeId || null,
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        if (values.id) {
          await CustomerServices.update(values.id, values);
          toast.success("Customer updated successfully.");
        } else {
          const newCustomer = await CustomerServices.create(values);
          toast.success("New customer is added successfully");
          resetForm();
          if (onCustomerAdded) onCustomerAdded(newCustomer);
          toggleModal();
        }
        fetchCustomers();
        toggleModal();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      } finally {
        setLoading(false);
      }
    },
  });
  // Reset form when modal closes
  useEffect(() => {
    if (!modal) {
      formik.resetForm();
    }
  }, [modal]);
  const handleCustomerTypeChange = (selectedOption) => {
    formik.setFieldValue(
      "customerTypeId",
      selectedOption ? selectedOption.value : null
    );
  };

  const customerTypeOptions = customerTypeData
    .filter((type) => type.isActive) // only active
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const selectedCustomerType = customerTypeOptions.find(
    (option) => option.value === formik.values.customerTypeId
  );

  useEffect(() => {
    // Only for NEW customer (not edit)
    if (
      !selectedCustomer?.id &&
      customerTypeOptions.length > 0 &&
      formik.values.customerTypeId === null
    ) {
      formik.setFieldValue("customerTypeId", customerTypeOptions[0].value);
    }
  }, [customerTypeOptions, selectedCustomer]);

  return (
    <Offcanvas
      isOpen={modal}
      toggle={toggleModal}
      direction="end"
      backdrop={true}
      scrollable
      style={{ width: "420px" }}
    >
      <OffcanvasHeader toggle={toggleModal} className="border-bottom">
        <i className="bx bx-plus me-2"></i> Add Customer
      </OffcanvasHeader>
      <Form
        onSubmit={formik.handleSubmit}
        className="d-flex flex-column flex-grow-1"
      >
        <OffcanvasBody className="d-flex flex-column p-3">
          {/* MAIN CONTENT */}
          <div className="flex-grow-1 overflow-auto">
            {/* First Name */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">First Name</Label>
              <Input
                id="firstName"
                name="firstName"
                type="text"
                className="form-control shadow-sm"
                placeholder="First Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstName}
                invalid={
                  !!(formik.touched.firstName && formik.errors.firstName)
                }
              />
              {formik.touched.firstName && formik.errors.firstName && (
                <FormFeedback type="invalid">
                  {formik.errors.firstName}
                </FormFeedback>
              )}
            </div>

            {/* Last Name */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Last Name</Label>
              <Input
                id="lastName"
                name="lastName"
                type="text"
                className="form-control shadow-sm"
                placeholder="Last Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastName}
                invalid={!!(formik.touched.lastName && formik.errors.lastName)}
              />
              {formik.touched.lastName && formik.errors.lastName && (
                <FormFeedback type="invalid">
                  {formik.errors.lastName}
                </FormFeedback>
              )}
            </div>

            {/* Email */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Email</Label>
              <Input
                id="email"
                name="email"
                type="email"
                className="form-control shadow-sm"
                placeholder="Enter email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                invalid={!!(formik.touched.email && formik.errors.email)}
              />
              {formik.touched.email && formik.errors.email && (
                <FormFeedback type="invalid">
                  {formik.errors.email}
                </FormFeedback>
              )}
            </div>

            {/* Address */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Address</Label>
              <Input
                id="address"
                name="address"
                type="text"
                className="form-control shadow-sm"
                placeholder="Enter address"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address}
                invalid={!!(formik.touched.address && formik.errors.address)}
              />
              {formik.touched.address && formik.errors.address && (
                <FormFeedback type="invalid">
                  {formik.errors.address}
                </FormFeedback>
              )}
            </div>

            {/* Phone Number */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Phone Number</Label>
              <Input
                id="phoneNo"
                name="phoneNo"
                type="text" // keep as text so value stays string
                inputMode="numeric" // mobile shows numeric keypad
                pattern="[0-9]*" // restricts to digits
                className="form-control shadow-sm"
                placeholder="Enter phone number"
                value={formik.values.phoneNo}
                onChange={(e) => {
                  // Allow only digits
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  formik.setFieldValue("phoneNo", onlyNums);
                }}
                onBlur={formik.handleBlur}
                invalid={!!(formik.touched.phoneNo && formik.errors.phoneNo)}
              />
              {formik.touched.phoneNo && formik.errors.phoneNo && (
                <FormFeedback type="invalid">
                  {formik.errors.phoneNo}
                </FormFeedback>
              )}
            </div>

            {/* Customer Type */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Customer Type</Label>
              <Select
                id="customerTypeId"
                name="customerTypeId"
                options={customerTypeOptions}
                value={selectedCustomerType || null}
                onChange={handleCustomerTypeChange}
                placeholder="Select Customer Type"
                isClearable
                className={
                  formik.touched.customerTypeId && formik.errors.customerTypeId
                    ? "is-invalid"
                    : ""
                }
              />
              {formik.touched.customerTypeId &&
                formik.errors.customerTypeId && (
                  <div
                    className="text-danger mt-1"
                    style={{ fontSize: "0.875rem" }}
                  >
                    {formik.errors.customerTypeId}
                  </div>
                )}
            </div>
          </div>

          {/* FOOTER BUTTONS */}
          <div
            className="bg-white border-top pt-3 pb-3 d-flex justify-content-between gap-2 position-sticky"
            style={{ bottom: 0, left: 0 }}
          >
            <Button
              color="danger"
              onClick={toggleModal}
              className="w-50 border shadow-sm"
            >
              Cancel
            </Button>
            <Button
              color="primary"
              className="w-50 shadow-sm"
              type="submit"
              disabled={loading}
            >
              {loading && <Spinner size="sm" className="me-2" />}
              {loading
                ? selectedCustomer?.id
                  ? "Updating..."
                  : "Creating..."
                : selectedCustomer?.id
                ? "Update"
                : "Create"}
            </Button>
          </div>
        </OffcanvasBody>
      </Form>
    </Offcanvas>
  );
};

export default MobileCustomerForm;
